import React, { Fragment } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import AccountSupportCenter from "../support/AccountSupportCenter";

const JobseekerSupportPage = () => (
  <Fragment>
    <Breadcrumbs mainTitle="Help & Support" parent="Jobseeker" title="Need Help" />
    <Container fluid={true}>
      <AccountSupportCenter variant="jobseeker" />
    </Container>
  </Fragment>
);

export default JobseekerSupportPage;
